import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import Button from "../button";
import "./style.css";

const RoleSwitchSuccessModal = ({
  show,
  close,
  title,
  subtitle,
  continueText,
}) => {
  return (
    <Modal
      show={show}
      centered
      onHide={close}
      className="role-switch-success-modal"
      dialogClassName="role-switch-success-modal-dialog"
    >
      <Modal.Header className="role-switch-success-modal-header border-0 p-0">
        <button
          type="button"
          className="role-switch-success-modal-close"
          aria-label="Close"
          onClick={close}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal.Header>
      <Modal.Body className="role-switch-success-modal-body text-center">
        <div className="role-switch-success-icon" aria-hidden="true">
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <h4 className="role-switch-success-modal-heading">{title}</h4>
        <p className="role-switch-success-modal-text">{subtitle}</p>
        <Button
          text={continueText}
          className="role-switch-success-modal-button"
          onClick={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default RoleSwitchSuccessModal;
